<template>
    <div :class="[prefixCls + '-body']">
        <tree-table-node
            v-for="(node, i) in list"
            :key="node.nodeKey"
            :data="node.node"
            :columns="endColumns"
            :node="node"
            :location="location"
            :validations="getValidations(node.nodeKey)"
        >
        </tree-table-node>
    </div>
</template>
<script>
import TreeTableNode from './tree-table-node.vue'

export default {
    name: 'TreeTableBody',
    components: {
        TreeTableNode,
    },
    inject: ['treeRoot', 'virtualList'],
    props: {
        location: {
            type: String,
            default: 'middle',
            validator: (val) => ['left', 'middle', 'right'].indexOf(val) >= 0,
        },
        list: {
            type: Array,
            default: () => [],
        },
        columns: {
            type: Array,
            default: function () {
                return []
            },
        },
    },
    computed: {
        prefixCls() {
            return 'ivu-tree-table'
        },
        endColumns() {
            return this.columns.filter((c) => c._isEnd)
        },
    },
    mounted() {
        var virtualList = this.virtualList,
            kls = '.' + this.prefixCls + '-node',
            map = Array.prototype.map

        if (virtualList.virtualAdjust) {
            // 高度自适应计算
            this.$watch(
                'list',
                function () {
                    this.$nextTick(() => {
                        virtualList.adjustVirtualHeight(
                            map.call(
                                this.$el.querySelectorAll(kls),
                                (el) => el.offsetHeight
                            )
                        )
                    })
                },
                {
                    immediate: true,
                }
            )
        }
    },
    methods: {
        getValidations(nodeKey) {
            return this.treeRoot.validationMap[nodeKey] || {}
        },
    },
}
</script>
